import type {RutaProd} from '../../../../runtime/rutas';
export default {
  "ruta": "/sistema/mi-licencia",
  "alias": [],
  "documento": "raiz",
  "acceso": "sesion",
  "filas": [
    "157"
  ],
  "cita": "Controllers/MiLicenciaController.cs"
} satisfies RutaProd;
